import { AvForm } from "availity-reactstrap-validation"

import { ModalBody, ModalFooter } from "reactstrap"

import {
    CustomButton,
    CustomModal,
    showToast
} from "components/Common"

import { AuthorizeViettel } from "helpers/app-backend/testResult_backend_helper"
import { getUserInfoStorage } from "helpers/utilities"
import React, { useState } from "react"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { updateResultComment } from "store/actions"

const CheckExpireSADViettelModal = ({
    modal,
    toggle,
    t,
    isExpired,
}) => {
    const [message, setMessage] = useState("")
    const submit = async () => {
        let userId = getUserInfoStorage("sub")
        const res = await AuthorizeViettel({ UserId: userId })
        if (res && res.message === "") {
            showToast("Gia hạn thành công")
            toggle()
        }
        else {
            setMessage(res.message)
        }
    }
    return (
        <React.Fragment>
            <CustomModal modal={modal} title={t(isExpired == null ?"Thông báo":"Cấu hình ký số hết hạn")} onToggle={toggle} size="lg">
                <ModalBody>
                    <AvForm
                        id="concludeForm12"
                    >
                        {isExpired == null ?
                            <div className="my-2">
                                <span className="h5">{t(`Tài khoản chưa được cấu hình ký số, vui lòng dùng tài khoản khác.`)}</span>
                            </div>
                            :
                            <>
                                <div className="my-2">
                                    <span className="h5">{t(`Cấu hình ký số của tài khoản hết hạn, vui lòng nhấn vào "Gia hạn" và xác nhận trên ứng dụng MySign`)}</span>
                                </div>
                                <div className="my-2">
                                    <span className="text-danger h5">{t(message)}</span>
                                </div>
                                <div className="text-center">
                                    <CustomButton
                                        isEdit
                                        text={t("common:Gia hạn")}
                                        type="button"
                                        onClick={() => {
                                            submit()
                                        }}
                                        data-dismiss="modal"
                                        color="primary"
                                        className="button-width"
                                    />
                                </div>
                            </>
                        }
                    </AvForm>

                </ModalBody>
                <ModalFooter>
                    <CustomButton
                        text={t("common:Cancel")}
                        type="button"
                        onClick={toggle}
                        data-dismiss="modal"
                        className="button-width"
                    />
                </ModalFooter>
            </CustomModal>
        </React.Fragment>
    )
}

CheckExpireSADViettelModal.defaultProps = {}

const mapStateToProps = ({ testResult }) => ({
    resultComment: testResult.testResult.resultComment || {},
    testResult: testResult.testResult || {}
})

const mapDispatchToProps = dispatch => ({
    onUpdateResultComment: payload => dispatch(updateResultComment(payload)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation(["testResultPage", "common"])(CheckExpireSADViettelModal))
